import React from 'react';
import { useTranslation } from 'react-i18next';
import { faBuildingColumns } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, EndpointDoc, InfoCard } from '../../../components/apidocs';
import { BANKS_ENDPOINTS } from '../data/banks';

const BanksSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionTitle icon={faBuildingColumns} iconColor="bg-gradient-to-br from-teal-400 to-cyan-500">
        Banks API
      </SectionTitle>
      <p className="text-gray-500 dark:text-slate-400 mb-5 text-sm">{t('apiDocs.banksApiDesc')}</p>

      {BANKS_ENDPOINTS(t).map((spec, idx) => <EndpointDoc key={idx} {...spec} />)}

      <InfoCard type="tip" title="Tips">
        {t('apiDocs.banksTip')}
      </InfoCard>
    </div>
  );
};

export default BanksSection;
